import { Component, Inject, OnInit, ViewEncapsulation, inject, signal } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { finalize } from "rxjs/operators";
import { TranslocoService } from "@jsverse/transloco";
import { BaseDialogComponent } from "../../core/base-dialog/base-dialog.component";
import { PendingTermsOfServiceSignatureService } from "./pending-terms-of-service-signature.service";
import { FuseProgressBarService } from "../../../../@fuse/components/progress-bar/progress-bar.service";
import { NotifyService } from "abp-ng2-module";

export const PENDING_TERMS_OF_SERVICE_DIALOG_PANEL_CLASS = "pending-terms-of-service-signature-dialog";

@Component({
    selector: "pending-terms-of-service-signature",
    encapsulation: ViewEncapsulation.None,
    templateUrl: "./pending-terms-of-service-signature.component.html",
    styleUrls: ["./pending-terms-of-service-signature.component.scss"],
})
export class PendingTermsOfServiceSignatureComponent
    extends BaseDialogComponent<PendingTermsOfServiceSignatureComponent>
    implements OnInit
{
    readonly notify = inject(NotifyService);

    private readonly _transloco = inject(TranslocoService);

    readonly termPage = signal(false);

    readonly signing = signal(false);

    description: Promise<string>;

    content: Promise<string>;

    constructor(
        private _service: PendingTermsOfServiceSignatureService,
        public dialogRef: MatDialogRef<PendingTermsOfServiceSignatureComponent>,
        private _progressBarService: FuseProgressBarService,
        @Inject(MAT_DIALOG_DATA) public data
    ) {
        super(dialogRef);
    }

    ngOnInit(): void {
        this.description = this._service.fetchUrl(this.data.descriptionLink);
        this.content = this._service.fetchUrl(this.data.contentLink);
    }

    next() {
        this.termPage.set(true);
    }

    sign() {
        this._progressBarService.show();
        this.signing.set(true);
        this._service
            .sign(this.data.id)
            .pipe(
                finalize(() => {
                    this.signing.set(false);
                    this._progressBarService.hide();
                })
            )
            .subscribe((signature) => {
                if (signature) {
                    this.notify.success(this._transloco.translate("pending-terms-of-service.signed"));
                    this.dialogRef.close();
                }
            });
    }
}
